import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { PendingActions, UpdatePendingCompleted } from './pending.actions';
import { PendingCollectionService } from '../../services/pending-collection.service';

@Injectable()
export class PendingEffects {
  private actions$ = inject(Actions);
  private pendingCollection = inject(PendingCollectionService);


  queryPending$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(PendingActions.UPDATE_PENDING),
    switchMap(() => {
      this.pendingCollection.syncPending();
      return of(new UpdatePendingCompleted());
    }),
  ));

}
